<template>
  <div id="app">
    <v-app id="inspire" v-if="!$route.meta.plainLayoutLogin">

      <v-navigation-drawer fixed :clipped="$vuetify.breakpoint.mdAndUp" app v-model="drawer">
        <v-list dense>
          <template v-for="item in items">
          <v-layout row v-if="item.heading" align-center :key="item.heading" >
            <v-flex xs6>
              <v-subheader v-if="item.heading"> {{ item.heading }} </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group v-else-if="item.children" v-model="item.model" :key="item.text" :prepend-icon="item.icon " append-icon="" >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title> {{ item.text }} </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-for="(child, i) in item.children" :key="i" :to="child.to" >   
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title> {{ child.text }} </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :to="item.to" :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="fontLao"> {{ item.text }} </v-list-tile-title>  
            </v-list-tile-content>
          </v-list-tile>
          </template>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar color="blue darken-3" dark app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed>
        <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
          <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
          <span class="hidden-sm-and-down">Stock Sys</span>
        </v-toolbar-title>

        <!-- <v-text-field flat solo-inverted prepend-icon="search" label="Search" class="hidden-sm-and-down" ></v-text-field> -->

        <v-spacer></v-spacer>

        <span v-if="user"> {{user.email}} </span>

        <v-btn icon>
          <v-icon @click="logout()">exit_to_app</v-icon>
        </v-btn>
      </v-toolbar>

      <v-content>
      <!-- <v-container fluid fill-height> -->
      <!-- <v-layout justify-center align-center> -->

      <router-view/>    
      <!-- <v-tooltip right>
      <v-btn icon large :href="source" target="_blank" slot="activator" >
        <v-icon large>code</v-icon>
      </v-btn>
      <span>Source</span>
      </v-tooltip> -->
      <!-- </v-layout> -->
      <!-- </v-container> -->
      </v-content>
    </v-app>

    <v-app v-if="$route.meta.plainLayoutLogin">
      <router-view></router-view>
    </v-app>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import db from '@/firebase/init'
export default {
  name: "App",
  data: () => ({
    dialog: false,
    email:null,
    drawer: null,
    user:null,
    items: []
  }),
  props: {
    source: String
  },
  methods:{
    logout(){
      firebase.auth().signOut().then(()=>{
       
        location.reload();
       // this.$router.push({name:'Login'})
        
      })
    }
  },
  created(){
  firebase.auth().onAuthStateChanged(user=>{
    if(user) {
      this.user =user
      let menuitem =null
      let _this =this
      db.collection('users').doc(user.uid).get()
      .then(function(doc) {
        if (doc.exists) {
          //  console.log("Document data:", doc.data());
          let lv= doc.data().lv;
          if(doc.data().suppliers){
            _this.items.push({ icon: 'person', text: 'ຜູ້ສະໜອງ',to:'/suppliers' }) 
          }
          if(doc.data().suppliers){
            _this.items.push({ icon: 'person', text: 'ຜູ້ຂາຍ',to:'/seller' }) 
          }
          if(doc.data().categories){
            _this.items.push({ icon: 'chrome_reader_mode', text: 'ປະເພດສິນຄ້າ',to:'/categories' })
          }
          if(doc.data().products){
            _this.items.push({ icon: 'shopping_cart', text: 'ສິນຄ້າ' ,to:'/products' })
          }
          if(doc.data().import){
            _this.items.push({ icon: 'add_circle', text: 'ສິນຄ້າຮັບເຂົ້າ',to:'/import' })
          }
          if(doc.data().export){
            _this.items.push({ icon: 'remove_circle', text: 'ສິນຄ້າຂາຍອອກ',to:'/export' })
          }
          if(doc.data().import){
            _this.items.push({ icon: 'add_circle', text: 'ຕິດຕາມສິນຄ້າຮັບເຂົ້າ',to:'/tracking' })
          }
          if(doc.data().stock){
            _this.items.push({ icon: 'featured_play_list', text: 'Stock',to:'/stock' })
          }
          if(doc.data().customer){
            _this.items.push({  icon: 'people', text: 'ລູກຄ້າ' ,to:'/customer' })
          }
          if(doc.data().rate){
            _this.items.push({icon: 'attach_money', text: 'ອັດຕາແລກປ່ຽນ',to:'/rate'})
          }
          if(doc.data().unit){
            _this.items.push({ icon: 'functions', text: 'ຫົວໜ່ວຍ',to:'/unit'})
          }
          if(doc.data().report){   
            _this.items.push(
            { 
              icon: 'note', text: 'ລາຍງານ',
              children: [
                { icon: 'note', text: 'ລາຍງານສິນຄ້າຮັບເຂົ້າ', to: '/ReportImport' },
                { icon: 'note', text: 'ລາຍງານສິນຄ້າຮັບເຂົ້າຕາມພະແນກ', to: '/ReportImportCat' },
                { icon: 'note', text: 'ລາຍງານຄັງສາງ', to: '/ReportStockUser' },
                { icon: 'note', text: 'ລາຍງານຍອດຂາຍຕາມໃບບິນ', to: '/ReportSaleBill' },
                { icon: 'note', text: 'ລາຍງານຍອດຂາຍຕາມລູກຄ້າ', to: '/ReportSale' },
                { icon: 'note', text: 'ລາຍງານຍອດຂາຍຕາມພະແນກ', to: '/ReportStockCat' },
                { icon: 'note', text: 'ລວມລາຍງານຄ້າງສາງທຸກພະແນກ', to: '/ReportYear' },
                { icon: 'note', text: 'ລາຍງານລາຍຮັບ - ລາຍຈ່າຍ', to: '/ReportAll' }
              ]
            })
          }
          if(doc.data().report3m){
            _this.items.push({ icon: 'note', text: 'ລາຍງານຄັງສາງ',to:'/ReportStock3m'},
                             { icon: 'note', text: 'ລາຍງານຍອດຂາຍຕາມໃບບິນ', to: '/ReportSaleBill' },
                              { icon: 'note', text: 'ລາຍງານຍອດຂາຍຕາມລູກຄ້າ', to: '/ReportSale3m' }
                )
          }
          if(doc.data().huanar){
            _this.items.push({ icon: 'spellcheck', text: 'ຈັດການ ຫົວຂໍ້',to:'/finheader'})
            _this.items.push({ icon: 'account_balance_wallet', text: 'ຈັດການ ລາຍຮັບ - ຈ່າຍ',to:'/finance'})     
          }
          if(doc.data().admin){
            _this.items.push({ icon: 'note', text: 'ລາຍງານຍອດຂາຍຕາມພະແນກ ເກົ່າ',to:'/ReportStock/2'})
          }
          // _this.items.push(
            // {  icon: 'settings', text: 'ຕັ້ງຄ່າ' ,to:'/unit'},
            // {icon: 'help', text: 'ຊ່ວຍເຫຼືອ' },
            // { icon: 'feedback', text: 'Send feedback'}
          // )
        } else {
          console.log("No such document!");
        }
      }).catch(function(error) {
        console.log("Error getting document:", error);
      });
      this.items =_this.items;
    } else { 
      this.user =null
    }

  })
  }

};
</script>

<style>
.fontLao{
font-family: phetsarath ot !important;
}
.fixtable>div>  td:first-child,
.fixtable>div>  table.v-table tbody td:not(:first-child),
.fixtable>div>  table.v-table tbody th:first-child,
.fixtable>div>  table.v-table tbody th:not(:first-child),
.fixtable>div>  table.v-table thead td:first-child, 
.fixtable>div>  table.v-table thead td:not(:first-child),
.fixtable>div>  table.v-table thead th:first-child,
.fixtable>div>  table.v-table thead th:not(:first-child) {
    padding: 2px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue